// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Cache bust: Unified button styling using reflection-btn-* classes 2026-01-05-v2 */
:root {
  /* Theme colors - will be overridden by ThemeContext */
  --color-primary: #3b82f6;
  --color-primary-hover: #2563eb;
  --color-secondary: #667eea;
  --color-secondary-hover: #5568d3;
  --color-danger: #ef4444;
  --color-danger-hover: #dc2626;
  --color-success: #10b981;
  --color-success-hover: #059669;
  --color-background: #f3f4f6;
  --color-card-bg: #ffffff;
  --color-text: #1f2937;
  --color-text-secondary: #6b7280;
  --color-text-muted: #374151;
  --color-border: #d1d5db;
  --color-border-light: #e5e7eb;
  --color-input-bg: #ffffff;
  --color-input-focus: #3b82f6;

  /* Button text colors */
  --color-dark-button-text: #ffffff;
  --color-light-button-text: #000000;

  /* Legacy support - maps to dark button text */
  --color-button-text: #ffffff;

  --color-gradient-start: #667eea;
  --color-gradient-end: #764ba2;
  --color-yellow-gradient-start: #F5FBC2;
  --color-yellow-gradient-end: #F0E266;
  --color-active-bg: #fde047;
  --color-active-text: #1f2937;
  --color-header-bg-start: #F5FBC2;
  --color-header-bg-end: #F0E266;
  --color-header-text: #1f2937;
  --color-header-text-secondary: #6b7280;

  /* Additional semantic colors */
  --color-warning: #f59e0b;
  --color-warning-hover: #d97706;
  --color-info: #3b82f6;
  --color-info-bg: #dbeafe;
  --color-info-text: #1e40af;
  --color-error-bg: #fee2e2;
  --color-error-text: #991b1b;
  --color-success-bg: #d1fae5;
  --color-success-text: #065f46;

  /* Neutral colors */
  --color-white: #ffffff;
  --color-black: #000000;
  --color-gray-50: #f9fafb;
  --color-gray-800: #1f2937;

  /* Reflection selection states - will be overridden by theme */
  --color-reflection-show-bg: #dbeafe;
  --color-reflection-edit-bg: #d1fae5;
  --color-reflection-show-shadow: rgba(59, 130, 246, 0.15);
  --color-reflection-edit-shadow: rgba(16, 185, 129, 0.15);
}

.app {
  min-height: 100vh;
  position: relative;
}

/* Fixed background image - stays in place while content scrolls */
.app::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--background-image, none);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--color-primary);
  background-blend-mode: multiply;
  background-attachment: fixed;
  pointer-events: none;
  z-index: -1;
}

/* Studio view uses its own background image, same theme blending */
.app.view-studio::after {
  background-image: var(--studio-background-image);
}

/* Gradient overlay - very transparent to let background image dominate */
.app::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);
  opacity: 0.2;
  pointer-events: none;
  z-index: 0;
}

.app > * {
  position: relative;
  z-index: 10;
}

/* ========================================================================
   RECORDING FOCUS MODE - BLUR EFFECT
   ========================================================================
   ⚠️ IMPORTANT: This class is applied to most UI elements during recording

   When a user is recording video/audio (or during countdown), almost ALL
   interactive elements get this class applied to maintain focus on recording.

   The class provides:
   - Visual blur (5px) to reduce distraction
   - Reduced opacity (0.6) to dim non-recording content
   - pointer-events: none to disable ALL clicking/interaction

   When adding new buttons, inputs, or interactive elements to the app,
   consider if they should be blurred during recording. Most should be!

   Elements that DON'T get blurred:
   - The active recording controls (RecordingSection, PreviewSection)

   See App.js state management comments for full list of disabled elements.
   ======================================================================== */
.blur-when-recording {
  filter: blur(5px);
  opacity: 0.6;
  pointer-events: none;
  transition: filter 0.3s ease, opacity 0.3s ease;
}

/* Smooth transition animation */
.app[data-recording="active"] .blur-when-recording {
  animation: fadeBlur 0.3s ease-out;
}

@keyframes fadeBlur {
  from {
    filter: blur(0);
    opacity: 1;
  }
  to {
    filter: blur(5px);
    opacity: 0.6;
  }
}

/* Header */
.header {
  background: linear-gradient(to right, var(--color-header-bg-start), var(--color-header-bg-end));
  padding: 1.5rem;
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1));
  position: relative;
  z-index: 100;
}

.header--sticky {
  position: sticky;
  top: 0;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  font-size: 1.8rem;
  color: var(--color-header-text);
  margin-bottom: 0.25rem;
}

.header p {
  font-size: 0.875rem;
  color: var(--color-header-text-secondary);
}

.header-logo {
  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.8))
          drop-shadow(0 0 2.5px rgba(255, 255, 255, 0.6));
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-info span {
  color: var(--color-header-text);
  font-weight: 500;
}

.user-info button {
  padding: 0.5rem 1rem;
  background: var(--color-danger);
  color: var(--color-button-text);
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
}

.user-info button:hover {
  background: var(--color-danger-hover);
}

/* Categories */
.categories {
  background: rgba(255, 255, 255, 0.05);
  padding: 1rem;
  overflow-x: auto;
  display: flex;
  gap: 0.5rem;
  white-space: nowrap;
  backdrop-filter: blur(10px);
}

.categories button {
  padding: 1rem;
  background: var(--color-primary);
  color: var(--color-button-text);
  border: none;
  border-radius: 0.5rem 0.5rem 0 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  min-width: 100px;
  max-width: 120px;
  transition: background 0.2s;
  white-space: normal;
  word-wrap: break-word;
  text-align: center;
}

.categories button:hover {
  background: var(--color-primary-hover);
}

.categories button.active {
  background: linear-gradient(to bottom, var(--color-yellow-gradient-start), var(--color-yellow-gradient-end));
  color: var(--color-active-text);
}

/* Invert white/light icons to dark when category is active */
.categories button.active .icon img {
  filter: invert(1);
}

.categories .icon {
  font-size: 1.5rem;
}

/* View Toggle */
.view-toggle {
  max-width: 28rem;
  margin: 1.5rem auto;
  background: var(--color-card-bg);
  border-radius: 9999px;
  display: flex;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.view-toggle button {
  flex: 1 1;
  padding: 0.75rem;
  background: var(--color-card-bg);
  color: var(--color-text-secondary);
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.view-toggle button.active {
  background: var(--color-active-bg);
  color: var(--color-active-text);
}

/* Main Content */
.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.prompts-list,
.reflections-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.prompt-card {
  background: var(--color-card-bg);
  border-radius: var(--radius-card, 8px);
  padding: 1.5rem;
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1));
  border: 2px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: all 0.3s ease;
}

.prompt-card:hover {
  box-shadow: var(--shadow-lg, 0 4px 8px rgba(0,0,0,0.15));
  transform: translateY(-2px);
}

.prompt-card.expanded {
  background: linear-gradient(to bottom, var(--color-yellow-gradient-start), var(--color-yellow-gradient-end));
  border: 3px solid var(--color-yellow-gradient-end);
  box-shadow: 0 8px 16px rgba(0,0,0,0.15), 0 0 0 1px var(--color-yellow-gradient-end);
  transform: scale(1.01);
  transition: all 0.3s ease;
}

.prompt-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}

.prompt-content,
.reflection-content {
  flex: 1 1;
}

.prompt-reflections {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-left: 2rem;
  padding-left: 1rem;
}

.reflection-inline-card {
  position: relative; /* Needed for absolute positioning of NEW badge */
  background: var(--color-card-bg);
  border-radius: 0.375rem;
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-template-rows: auto auto auto auto;
  align-items: center;
  row-gap: 0.5rem;    /* Reduces vertical spacing from 16px to 8px */
  column-gap: 1rem;   /* Keeps horizontal spacing at 16px */
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.reflection-prompt-text {
  grid-column: 1 / -1;
  grid-row: 1;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  font-style: italic;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 0.5rem;
}

/* NEW Badge for unviewed shared reflections */
.new-badge {
  position: absolute;
  top: -6px;
  left: 8px;
  background: #ff0000;
  color: white;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 20;
  transition: all 0.2s ease;
  box-shadow: 0 0 8px rgba(255, 0, 0, 0.6), 0 0 16px rgba(255, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.2);
  -webkit-user-select: none;
          user-select: none;
}

.new-badge:hover {
  transform: scale(1.05);
  box-shadow: 0 0 12px rgba(255, 0, 0, 0.8), 0 0 24px rgba(255, 0, 0, 0.5), 0 3px 6px rgba(0, 0, 0, 0.3);
}

.new-badge:active {
  transform: scale(0.95);
}

.prompt-new-badge {
  top: 3px;
  left: 8px;
  right: auto;
}

.match-badge {
  position: absolute;
  top: -6px;
  left: 8px;
  background: #27ae60;
  color: white;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 2;
  box-shadow: 0 0 8px rgba(39, 174, 96, 0.6), 0 0 16px rgba(39, 174, 96, 0.4), 0 2px 4px rgba(0, 0, 0, 0.2);
}

.match-badge.with-new {
  left: 55px;
}

.prompt-match-badge {
  top: 3px;
  left: 8px;
  right: auto;
}

.prompt-match-badge.with-new {
  left: 55px;
}

.reflection-inline-note {
  color: var(--color-text-muted);
  font-size: 0.875rem;
  grid-column: 1;
  grid-row: 2;
}

.reflection-inline-buttons {
  display: flex;
  gap: 0.5rem;
  grid-column: 2;
  grid-row: 2;
}

.reflection-btn-show,
.reflection-btn-edit,
.reflection-btn-delete,
.reflection-btn-transcribe,
.reflection-btn-change-prompt {
  appearance: none !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--color-primary) !important;
  color: var(--color-button-text) !important;
  border: none !important;
  border-radius: 24px !important;
  cursor: pointer;
  font-size: 0.875rem;
  white-space: nowrap;
  transition: all 0.2s;
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05)) !important;
  outline: none !important;
}

.reflection-btn-show:hover,
.reflection-btn-edit:hover {
  background: var(--color-primary-hover) !important;
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;
  transform: translateY(-1px);
}

.reflection-btn-delete {
  background: var(--color-danger) !important;
}

.reflection-btn-delete:hover {
  background: #d32f2f !important;
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;
  transform: translateY(-1px);
}

.reflection-btn-transcribe {
  background: var(--color-secondary, #6c757d) !important;
}

.reflection-btn-transcribe:hover {
  background: var(--color-secondary-hover, #5a6268) !important;
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;
  transform: translateY(-1px);
}

.reflection-btn-change-prompt {
  background: var(--color-accent, #8b5cf6) !important;
}

.reflection-btn-change-prompt:hover {
  background: var(--color-accent-hover, #7c3aed) !important;
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;
  transform: translateY(-1px);
}

.reflection-btn-show.active {
  background: var(--color-primary) !important;
  box-shadow: 0 0 0 2px var(--color-primary-hover) !important;
}

.reflection-btn-edit.active {
  background: var(--color-success) !important;
  box-shadow: 0 0 0 2px var(--color-success-hover) !important;
}

.reflection-btn-edit.active:hover {
  background: var(--color-success-hover);
}

/* Button icons and counts */
.reflection-btn-show .icon,
.reflection-btn-edit .icon,
.reflection-btn-delete .icon {
  font-size: 1.2rem;
}

/* Context menu (ellipsis / more actions) */
.reflection-context-menu-container {
  position: relative;
}

.reflection-btn-more {
  appearance: none !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--color-primary) !important;
  color: var(--color-button-text) !important;
  border: none !important;
  border-radius: 24px !important;
  cursor: pointer;
  font-size: 1.1rem;
  letter-spacing: 2px;
  white-space: nowrap;
  transition: all 0.2s;
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05)) !important;
  outline: none !important;
}

.reflection-btn-more:hover {
  background: var(--color-primary-hover) !important;
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;
  transform: translateY(-1px);
}

.reflection-context-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: var(--color-card-bg);
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 140px;
  width: max-content;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.reflection-context-menu-item {
  width: 100%;
  padding: 0.75rem 1rem;
  text-align: left;
  background: var(--color-card-bg);
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  color: var(--color-text);
  font-size: 1rem;
}

.reflection-context-menu-item:first-child {
  border-radius: 0.5rem 0.5rem 0 0;
}

.reflection-context-menu-item:last-child {
  border-radius: 0 0 0.5rem 0.5rem;
}

.reflection-context-menu-item:hover {
  background: var(--color-background);
}

.reflection-context-menu-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.reflection-context-menu-item-danger {
  color: var(--color-danger, #e53935);
}

.reflection-context-menu-item-danger:hover {
  background: var(--color-background);
}

.reflection-inline-thumbnail {
  width: 80px;
  height: 60px;
  background: var(--color-black);
  border-radius: 0.375rem;
  overflow: hidden;
  grid-column: 3;
  grid-row: 2;
}

.reflection-shared-from {
  grid-column: 1 / -1;
  grid-row: 3;
  font-size: 0.75rem;
  color: var(--color-text-muted);
  font-style: italic;
  padding-top: 0.5rem;
  border-top: 1px solid var(--color-border);
}

.reflection-followup-indicator {
  grid-column: 1 / -1;
  grid-row: 4;
  font-size: 0.8rem;
  color: var(--color-primary);
  font-style: italic;
  padding-top: 0.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reflection-tree-wrapper {
  grid-column: 1 / -1;
  grid-row: -1;
  overflow-x: auto;
}

.reflection-inline-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.audio-placeholder,
.text-placeholder,
.reflection-thumbnail-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface);
  color: var(--color-text);
  font-size: 1.5rem;
  border: 2px solid var(--color-border);
  border-radius: 0.375rem;
}

.reflection-section {
  margin-bottom: 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: 0.375rem;
  overflow: hidden;
}

.reflection-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: var(--color-background);
  cursor: pointer;
  font-weight: 600;
  color: var(--color-text);
  transition: background 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.reflection-section-header:hover {
  background: var(--color-border-light);
}

/* Active section header - light blue background when expanded */
.reflection-section-header.active {
  background: var(--color-reflection-show-bg);
}

/* Disabled section header - during recording
   ⚠️ Applied to Video/Audio/Text section headers that are NOT currently recording
   Prevents users from collapsing the active recording or opening other sections */
.reflection-section-header.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}

.reflection-section-header.disabled:hover {
  background: var(--color-background);
}

.section-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-header-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.no-content-indicator {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--color-text-secondary);
  font-style: italic;
  opacity: 0.7;
}

.section-toggle {
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.reflection-section-content {
  padding: 1rem;
  background: var(--color-card-bg);
}

.reflection-section-content textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.375rem;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  background: var(--color-input-bg);
  color: var(--color-text);
}

.reflection-section-content textarea:focus {
  outline: none;
  border-color: var(--color-input-focus);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.reflection-section-content p {
  margin: 0;
  color: var(--color-text);
  white-space: pre-wrap;
}

.reflection-section-content p.no-content {
  color: var(--color-text-secondary);
  font-style: italic;
}

/* React-Quill WYSIWYG Editor Styles */
.reflection-section-content .quill {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 0.375rem;
}

.reflection-section-content .ql-toolbar {
  border: 1px solid var(--color-border);
  border-bottom: none;
  border-radius: 0.375rem 0.375rem 0 0;
  background: var(--color-background);
}

.reflection-section-content .ql-container {
  border: 1px solid var(--color-border);
  border-radius: 0 0 0.375rem 0.375rem;
  font-size: 1rem;
  font-family: inherit;
  min-height: 150px;
}

.reflection-section-content .ql-editor {
  color: var(--color-text);
  min-height: 150px;
  padding: 0.75rem;
}

.reflection-section-content .ql-editor.ql-blank::before {
  color: var(--color-text-secondary);
  font-style: italic;
}

/* Toolbar button colors */
.reflection-section-content .ql-toolbar .ql-stroke {
  stroke: var(--color-text);
}

.reflection-section-content .ql-toolbar .ql-fill {
  fill: var(--color-text);
}

/* Active toolbar buttons */
.reflection-section-content .ql-toolbar button:hover,
.reflection-section-content .ql-toolbar button.ql-active {
  background: var(--color-border-light);
}

/* Read-only mode (bubble theme) */
.reflection-section-content .ql-bubble .ql-editor {
  padding: 0;
  border: none;
}

/* Recording prompt box - appears above media during recording/countdown */
.recording-prompt-box {
  background: var(--color-card-bg);
  padding: 1.5rem 2rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border: 2px solid var(--color-primary);
  font-size: 1.75rem;
  line-height: 1.6;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-weight: bold;
  color: var(--color-text);
}

.btn-record,
.btn-delete-recording {
  padding: 0.375rem 0.75rem;
  border: none;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.btn-record {
  background: var(--color-primary);
  color: var(--color-button-text);
}

.btn-record:hover {
  background: var(--color-primary-hover);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.btn-delete-recording {
  background: var(--color-danger);
  color: var(--color-button-text);
}

.btn-delete-recording:hover {
  background: var(--color-danger-hover);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
}

/* Recording Controls */
.recording-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.recording-controls {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  padding: 0.5rem 0;
}

/* Primary button with pill style */
.btn-primary {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 9999px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  background: var(--color-primary);
  color: var(--color-button-text);
}

.btn-primary:hover {
  background: var(--color-primary-hover);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

/* Utility button: looks like a button, but deliberately lower-key than .btn-primary
   for secondary, "housekeeping" actions (e.g. resend a code/link) rather than the main action */
.btn-utility {
  padding: 0.5rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: 0.375rem;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: transparent;
  color: var(--color-text-secondary);
}

.btn-utility:hover:not(:disabled) {
  background: var(--color-border-light);
  border-color: var(--color-text-secondary);
}

.btn-utility:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-stop-recording,
.btn-pause-recording {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 9999px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.btn-stop-recording {
  background: var(--color-danger);
  color: var(--color-button-text);
}

.btn-stop-recording:hover {
  background: var(--color-danger-hover);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
  transform: translateY(-1px);
}

.btn-pause-recording {
  background: var(--color-primary);
  color: var(--color-button-text);
}

.btn-pause-recording:hover {
  background: var(--color-primary-hover);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

/* Audio Recording Indicator */
.audio-recording-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 2rem;
  background: var(--color-background);
  border-radius: 0.5rem;
}

.audio-recording-indicator span {
  font-size: 1rem;
  color: var(--color-text);
}

.recording-pulse {
  font-size: 3rem;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
}

/* Audio Playback with Waveform */
.audio-playback-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.prompt-actions {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: stretch;
  margin-left: auto;
  align-self: flex-start;
  flex-wrap: wrap;
  justify-content: flex-end;
}

@media (max-width: 640px) {
  .prompt-actions {
    flex-direction: column-reverse;
  }
}

/* Removed - now using reflection-btn-show class
.view-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  background: var(--color-card-bg);
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  gap: 0.5rem;
}

.view-button:hover {
  background: var(--color-primary);
  color: var(--color-button-text);
}

.view-button .icon {
  font-size: 1.2rem;
}
*/

.view-counts {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  font-size: 0.75rem;
  text-align: left;
}

.prompt-text,
.reflection-prompt {
  font-size: 1.125rem;
  color: var(--color-text);
  margin-bottom: 0.5rem;
}

.prompt-category,
.reflection-meta {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  font-style: italic;
}

.reflection-notes {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  font-style: italic;
  margin-top: 0.5rem;
}

/* Friend suggestion metadata on prompt cards */
.friend-suggestion-meta {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: rgba(59, 130, 246, 0.06);
  border-left: 3px solid var(--color-primary, #3b82f6);
  border-radius: 0 0.25rem 0.25rem 0;
  font-size: 0.8rem;
}

.friend-suggestion-from {
  display: inline-block;
  font-weight: 600;
  color: var(--color-primary, #3b82f6);
  margin-right: 0.5rem;
}

.friend-suggestion-date {
  display: inline-block;
  color: var(--color-text-secondary);
}

.friend-suggestion-note {
  margin: 0.35rem 0 0 0;
  color: var(--color-text-secondary);
  font-style: italic;
  line-height: 1.4;
}

.reflection-text {
  margin-top: 0.75rem;
  color: var(--color-text-muted);
}

/* Removed - now using reflection-btn-* classes
.prompt-card button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  padding: 0.5rem 1.5rem;
  background: var(--color-card-bg) !important;
  color: var(--color-danger) !important;
  border: 2px solid var(--color-danger) !important;
  border-radius: 24px !important;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s;
  height: 100%;
  outline: none !important;
}

.prompt-card button:hover {
  background: var(--color-danger) !important;
  color: var(--color-button-text) !important;
  transform: translateY(-1px);
  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;
}
*/

/* Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* Dark overlay with blur for true modal behavior */
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 50;
}

.modal-content {
  /* Glassmorphism effect for modal content */
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 1rem;
  max-width: 42rem;
  width: 100%;
  padding: 1.5rem;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.modal-header h3 {
  font-size: 1.25rem;
  color: var(--color-text);
  margin-bottom: 0.5rem;
}

.modal-header p {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin-bottom: 0.25rem;
}

.modal-header button {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-header button:hover {
  color: var(--color-text-muted);
}

.modal-content input[type="text"],
.modal-content input[type="email"],
.modal-content input[type="password"],
.modal-content input[type="tel"],
.modal-content input[type="number"],
.modal-content textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-family: inherit;
  background: var(--color-input-bg);
}

.modal-content input[type="checkbox"] {
  width: auto;
  margin-bottom: 0;
  padding: 0;
}

.modal-content input[type="text"]:focus,
.modal-content input[type="email"]:focus,
.modal-content input[type="password"]:focus,
.modal-content input[type="tel"]:focus,
.modal-content input[type="number"]:focus,
.modal-content textarea:focus {
  outline: none;
  border-color: var(--color-input-focus);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.video-preview,
.media-player {
  width: 100%;
  height: 16rem;
  background: var(--color-black);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.text-content {
  background: var(--color-gray-50);
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.modal-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
}

.modal-actions button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;
}

.modal-actions button:nth-child(1) {
  background: var(--color-danger);
  color: var(--color-button-text);
}

.modal-actions button:nth-child(1):hover {
  background: var(--color-danger-hover);
}

.modal-actions button:nth-child(2) {
  background: var(--color-primary);
  color: var(--color-button-text);
}

.modal-actions button:nth-child(2):hover {
  background: var(--color-primary-hover);
}

.modal-actions button:nth-child(3) {
  background: var(--color-success);
  color: var(--color-button-text);
}

.modal-actions button:nth-child(3):hover {
  background: var(--color-success-hover);
}

/* Login */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.login-box {
  /* Glassmorphism effect - used on standalone login page */
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 10px 40px rgba(0,0,0,0.15);
  width: 100%;
  max-width: 36rem; /* Increased from 24rem to prevent header text wrapping */
}

/* Auth form content inside modals - no background since modal already has glassmorphism */
.auth-form-content {
  /* No background or shadow - parent modal-content provides the glassmorphism */
}

.auth-form-content h1 {
  font-size: 1.5rem;
  color: var(--color-text);
  margin: 0;
}

.auth-form-content > p {
  color: var(--color-text-secondary);
  font-size: 0.85rem;
  margin: 0;
}

.auth-form-content form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.auth-form-content input {
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  font-size: 1rem;
  background: var(--color-input-bg);
}

.auth-form-content input:focus {
  outline: none;
  border-color: var(--color-input-focus);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.auth-form-content form button[type="submit"] {
  padding: 0.75rem;
  background: var(--color-primary);
  color: var(--color-button-text);
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.auth-form-content form button[type="submit"]:hover {
  background: var(--color-primary-hover);
}

.login-box h1 {
  font-size: 1.875rem;
  color: var(--color-text);
  text-align: center;
  margin-bottom: 0.5rem;
}

.login-box > p {
  text-align: center;
  color: var(--color-text-secondary);
  margin-bottom: 2rem;
  font-size: 0.875rem;
}

.login-box form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.login-box input {
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  font-size: 1rem;
  background: var(--color-input-bg);
}

.login-box input:focus {
  outline: none;
  border-color: var(--color-input-focus);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.login-box form button {
  padding: 0.75rem;
  background: var(--color-primary);
  color: var(--color-button-text);
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.login-box form button:hover {
  background: var(--color-primary-hover);
}

.toggle-mode {
  width: 100%;
  margin-top: 1rem;
  padding: 0.5rem;
  background: none;
  border: none;
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: underline;
}

.toggle-mode:hover {
  color: var(--color-text-muted);
}

.forgot-password-link {
  width: 100%;
  margin-top: 0.5rem;
  padding: 0.5rem;
  background: none;
  border: none;
  color: var(--color-primary);
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: underline;
}

.forgot-password-link:hover {
  color: var(--color-primary-hover);
}

.reset-message,
.error-message,
.success-message {
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.reset-message {
  background: var(--color-info-bg);
  color: var(--color-info-text);
  border: 1px solid var(--color-info);
}

.error-message {
  background: var(--color-error-bg);
  color: var(--color-error-text);
  border: 1px solid var(--color-danger);
}

.success-message {
  background: var(--color-success-bg);
  color: var(--color-success-text);
  border: 1px solid var(--color-success);
  text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
  }
  
  .categories {
    padding: 0.5rem;
  }
  
  .categories button {
    min-width: 80px;
    padding: 0.75rem;
    font-size: 0.875rem;
  }
  
  .prompt-card {
    flex-direction: column;
  }
  
  .prompt-card button {
    width: 100%;
  }
}

/* Ensure View and Record buttons have same height */
.prompt-actions {
  min-height: 48px;
}

.prompt-actions > button {
  align-self: stretch;
  min-height: 48px;
}

/* Profile Menu */
.profile-menu-container {
  position: relative;
}

.profile-avatar-button {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);
  color: var(--color-white);
  font-weight: bold;
  font-size: 1.2rem;
  border: 2px solid var(--color-white);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

.profile-avatar-button:hover {
  transform: scale(1.05);
}

.profile-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: var(--color-card-bg);
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 9999;
}

.profile-dropdown button {
  width: 100%;
  padding: 0.75rem 1rem;
  text-align: left;
  background: var(--color-card-bg);
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  color: var(--color-text);
  font-size: 1rem;
}

.profile-dropdown button:first-child {
  border-radius: 0.5rem 0.5rem 0 0;
}

.profile-dropdown button:last-child {
  border-radius: 0 0 0.5rem 0.5rem;
}

.profile-dropdown button:hover {
  background: var(--color-background);
}

/* Profile Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* Dark overlay with blur for true modal behavior */
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.profile-modal,
.password-modal {
  /* Glassmorphism effect for modal content */
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 1rem;
  padding: 2rem;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.profile-modal h2,
.password-modal h2 {
  margin-bottom: 1.5rem;
  color: var(--color-text);
  font-size: 1.5rem;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 500;
  color: var(--color-text-muted);
  font-size: 0.875rem;
}

.form-group input,
.form-group select {
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: border-color 0.2s;
  background: var(--color-input-bg);
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--color-secondary);
}

.form-group input.readonly-field {
  background: var(--color-background);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}

.change-password-btn {
  background: var(--color-warning);
  color: var(--color-white);
  border: none;
}

.change-password-btn:hover {
  background: var(--color-warning-hover);
}

.modal-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.modal-actions button {
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  background: var(--color-secondary);
  color: var(--color-button-text);
}

.modal-actions button:hover {
  background: var(--color-secondary-hover);
}

.modal-actions button:last-child:not(.change-password-btn) {
  background: var(--color-text-secondary);
}

.modal-actions button:last-child:not(.change-password-btn):hover {
  background: var(--color-text-muted);
}

/* Audio Equalizer Visual Feedback */
.equalizer-container {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  height: 40px;
  margin-bottom: 0.75rem;
  padding: 0 1rem;
}

.equalizer-bar {
  width: 6px;
  height: 8px;
  background: var(--color-secondary);
  border-radius: 3px;
  transition: height 0.1s ease;
}

/* Animate bars when playing */
.equalizer-container.playing .equalizer-bar {
  animation: equalize 0.8s ease-in-out infinite;
}

.equalizer-container.playing .equalizer-bar:nth-child(1) {
  animation-delay: 0s;
}

.equalizer-container.playing .equalizer-bar:nth-child(2) {
  animation-delay: 0.15s;
}

.equalizer-container.playing .equalizer-bar:nth-child(3) {
  animation-delay: 0.3s;
}

.equalizer-container.playing .equalizer-bar:nth-child(4) {
  animation-delay: 0.15s;
}

.equalizer-container.playing .equalizer-bar:nth-child(5) {
  animation-delay: 0s;
}

@keyframes equalize {
  0%, 100% {
    height: 8px;
  }
  25% {
    height: 30px;
  }
  50% {
    height: 15px;
  }
  75% {
    height: 25px;
  }
}

/* Add New Prompt Button */
.add-prompt-button-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1rem;
  margin-bottom: 0.5rem;
}

.add-prompt-button {
  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));
  color: var(--color-dark-button-text);
  border: none;
  border-radius: 9999px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-prompt-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.add-prompt-button:active {
  transform: translateY(0);
}

/* Filter Container */
.filter-container {
  display: inline-block;
}

.filter-toggle-button {
  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));
  color: var(--color-dark-button-text);
  border: none;
  border-radius: 9999px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-toggle-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.filter-toggle-button:active {
  transform: translateY(0);
}

.filter-box-wrapper {
  padding: 0 1rem;
  margin-bottom: 1rem;
}

.filter-box {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-box-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.filter-column {
  display: flex;
  flex-direction: column;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.filter-row:last-child {
  margin-bottom: 0;
}

.filter-column .filter-row:last-child {
  margin-bottom: 0.75rem;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #ffffff;
  font-weight: 600;
  min-width: 100px;
}

.filter-reset-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--color-border);
}

.filter-reset-btn {
  padding: 0.35rem 1rem;
  font-size: 0.8rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  cursor: pointer;
  color: #ffffff;
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}

.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px var(--color-primary);
}

.filter-search-input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
  color: #333;
  transition: border-color 0.2s;
}

.filter-search-input::placeholder {
  color: #999;
}

.filter-search-input:focus {
  outline: none;
  border-color: var(--color-primary);
}

.filter-dropdown {
  padding: 0.5rem 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
  color: #333;
  cursor: pointer;
  transition: border-color 0.2s;
  min-width: 160px;
  width: auto;
}

.filter-dropdown:focus {
  outline: none;
  border-color: var(--color-primary);
}

.filter-date-input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
  color: #333;
  transition: border-color 0.2s;
  font-family: inherit;
}

.filter-date-input:focus {
  outline: none;
  border-color: var(--color-primary);
}

/* Add New Prompt Modal */
.add-prompt-modal {
  /* Glassmorphism effect (inherits from .modal-content but with specific sizing) */
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  min-width: 500px;
  max-width: 600px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.add-prompt-modal h2 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: var(--color-text);
  font-size: 1.5rem;
}

.add-prompt-modal .form-group {
  margin-bottom: 1.5rem;
}

.add-prompt-modal .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--color-text);
  font-weight: 600;
  font-size: 0.95rem;
}

.add-prompt-modal textarea,
.add-prompt-modal select {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid var(--color-border);
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  background-color: var(--color-input-bg);
  color: var(--color-text);
  transition: border-color 0.2s;
}

.add-prompt-modal textarea:focus,
.add-prompt-modal select:focus {
  outline: none;
  border-color: var(--color-input-focus);
}

.add-prompt-modal textarea {
  resize: vertical;
  min-height: 100px;
}

.add-prompt-modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.add-prompt-modal .btn-cancel,
.add-prompt-modal .btn-save {
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 9999px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.add-prompt-modal .btn-cancel {
  background-color: var(--color-border);
  color: var(--color-text);
}

.add-prompt-modal .btn-cancel:hover {
  background-color: var(--color-text-secondary);
  color: var(--color-white);
}

.add-prompt-modal .btn-save {
  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));
  color: var(--color-button-text);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-prompt-modal .btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.add-prompt-modal .btn-save:active {
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oFAAoF;AACpF;EACE,sDAAsD;EACtD,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;;EAE5B,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;;EAElC,8CAA8C;EAC9C,4BAA4B;;EAE5B,+BAA+B;EAC/B,6BAA6B;EAC7B,sCAAsC;EACtC,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,4BAA4B;EAC5B,sCAAsC;;EAEtC,+BAA+B;EAC/B,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;;EAE7B,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;;EAEzB,8DAA8D;EAC9D,mCAAmC;EACnC,mCAAmC;EACnC,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,gDAAgD;AAClD;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mGAAmG;EACnG,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;6EAoB6E;AAC7E;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA,gCAAgC;AAChC;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE,+FAA+F;EAC/F,eAAe;EACf,uDAAuD;EACvD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE;yDACuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4GAA4G;EAC5G,+BAA+B;AACjC;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,uDAAuD;EACvD,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,4GAA4G;EAC5G,kDAAkD;EAClD,mFAAmF;EACnF,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,iDAAiD;EACrE,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,uCAAuC;EACvC,mBAAmB;EACnB,eAAe,KAAK,8CAA8C;EAClE,gBAAgB,IAAI,qCAAqC;EACzD,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qGAAqG;EACrG,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sGAAsG;AACxG;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,yGAAyG;AAC3G;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;;;;;EAOE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,2CAA2C;EAC3C,0CAA0C;EAC1C,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mEAAmE;EACnE,wBAAwB;AAC1B;;AAEA;;EAEE,iDAAiD;EACjD,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,4DAA4D;EAC5D,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yDAAyD;EACzD,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,2DAA2D;AAC7D;;AAEA;EACE,2CAA2C;EAC3C,2DAA2D;AAC7D;;AAEA;EACE,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;;;EAGE,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;AACpB;;AAEA;EAGE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,2CAA2C;EAC3C,0CAA0C;EAC1C,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mEAAmE;EACnE,wBAAwB;AAC1B;;AAEA;EACE,iDAAiD;EACjD,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gEAAgE;AAChE;EACE,2CAA2C;AAC7C;;AAEA;;kFAEkF;AAClF;EACE,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;;EAEE,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,YAAY;AACd;;AAEA,0EAA0E;AAC1E;EACE,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;gGACgG;AAChG;EACE,oBAAoB;EACpB,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;CAyBC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,oDAAoD;EACpD,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC;;AAED,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAmD;EACnD,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;EAME,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mGAAmG;EACnG,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yDAAyD;EACzD,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA,0FAA0F;AAC1F;EACE,8EAA8E;AAChF;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mGAAmG;EACnG,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAmD;EACnD,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,2CAA2C;EAC3C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,2FAA2F;EAC3F,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;EACE,2FAA2F;EAC3F,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,iFAAiF;EACjF,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uCAAuC;EACvC,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,2FAA2F;EAC3F,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Cache bust: Unified button styling using reflection-btn-* classes 2026-01-05-v2 */\n:root {\n  /* Theme colors - will be overridden by ThemeContext */\n  --color-primary: #3b82f6;\n  --color-primary-hover: #2563eb;\n  --color-secondary: #667eea;\n  --color-secondary-hover: #5568d3;\n  --color-danger: #ef4444;\n  --color-danger-hover: #dc2626;\n  --color-success: #10b981;\n  --color-success-hover: #059669;\n  --color-background: #f3f4f6;\n  --color-card-bg: #ffffff;\n  --color-text: #1f2937;\n  --color-text-secondary: #6b7280;\n  --color-text-muted: #374151;\n  --color-border: #d1d5db;\n  --color-border-light: #e5e7eb;\n  --color-input-bg: #ffffff;\n  --color-input-focus: #3b82f6;\n\n  /* Button text colors */\n  --color-dark-button-text: #ffffff;\n  --color-light-button-text: #000000;\n\n  /* Legacy support - maps to dark button text */\n  --color-button-text: #ffffff;\n\n  --color-gradient-start: #667eea;\n  --color-gradient-end: #764ba2;\n  --color-yellow-gradient-start: #F5FBC2;\n  --color-yellow-gradient-end: #F0E266;\n  --color-active-bg: #fde047;\n  --color-active-text: #1f2937;\n  --color-header-bg-start: #F5FBC2;\n  --color-header-bg-end: #F0E266;\n  --color-header-text: #1f2937;\n  --color-header-text-secondary: #6b7280;\n\n  /* Additional semantic colors */\n  --color-warning: #f59e0b;\n  --color-warning-hover: #d97706;\n  --color-info: #3b82f6;\n  --color-info-bg: #dbeafe;\n  --color-info-text: #1e40af;\n  --color-error-bg: #fee2e2;\n  --color-error-text: #991b1b;\n  --color-success-bg: #d1fae5;\n  --color-success-text: #065f46;\n\n  /* Neutral colors */\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-gray-50: #f9fafb;\n  --color-gray-800: #1f2937;\n\n  /* Reflection selection states - will be overridden by theme */\n  --color-reflection-show-bg: #dbeafe;\n  --color-reflection-edit-bg: #d1fae5;\n  --color-reflection-show-shadow: rgba(59, 130, 246, 0.15);\n  --color-reflection-edit-shadow: rgba(16, 185, 129, 0.15);\n}\n\n.app {\n  min-height: 100vh;\n  position: relative;\n}\n\n/* Fixed background image - stays in place while content scrolls */\n.app::after {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: var(--background-image, none);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: var(--color-primary);\n  background-blend-mode: multiply;\n  background-attachment: fixed;\n  pointer-events: none;\n  z-index: -1;\n}\n\n/* Studio view uses its own background image, same theme blending */\n.app.view-studio::after {\n  background-image: var(--studio-background-image);\n}\n\n/* Gradient overlay - very transparent to let background image dominate */\n.app::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);\n  opacity: 0.2;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.app > * {\n  position: relative;\n  z-index: 10;\n}\n\n/* ========================================================================\n   RECORDING FOCUS MODE - BLUR EFFECT\n   ========================================================================\n   ⚠️ IMPORTANT: This class is applied to most UI elements during recording\n\n   When a user is recording video/audio (or during countdown), almost ALL\n   interactive elements get this class applied to maintain focus on recording.\n\n   The class provides:\n   - Visual blur (5px) to reduce distraction\n   - Reduced opacity (0.6) to dim non-recording content\n   - pointer-events: none to disable ALL clicking/interaction\n\n   When adding new buttons, inputs, or interactive elements to the app,\n   consider if they should be blurred during recording. Most should be!\n\n   Elements that DON'T get blurred:\n   - The active recording controls (RecordingSection, PreviewSection)\n\n   See App.js state management comments for full list of disabled elements.\n   ======================================================================== */\n.blur-when-recording {\n  filter: blur(5px);\n  opacity: 0.6;\n  pointer-events: none;\n  transition: filter 0.3s ease, opacity 0.3s ease;\n}\n\n/* Smooth transition animation */\n.app[data-recording=\"active\"] .blur-when-recording {\n  animation: fadeBlur 0.3s ease-out;\n}\n\n@keyframes fadeBlur {\n  from {\n    filter: blur(0);\n    opacity: 1;\n  }\n  to {\n    filter: blur(5px);\n    opacity: 0.6;\n  }\n}\n\n/* Header */\n.header {\n  background: linear-gradient(to right, var(--color-header-bg-start), var(--color-header-bg-end));\n  padding: 1.5rem;\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1));\n  position: relative;\n  z-index: 100;\n}\n\n.header--sticky {\n  position: sticky;\n  top: 0;\n}\n\n.header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h1 {\n  font-size: 1.8rem;\n  color: var(--color-header-text);\n  margin-bottom: 0.25rem;\n}\n\n.header p {\n  font-size: 0.875rem;\n  color: var(--color-header-text-secondary);\n}\n\n.header-logo {\n  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.8))\n          drop-shadow(0 0 2.5px rgba(255, 255, 255, 0.6));\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-info span {\n  color: var(--color-header-text);\n  font-weight: 500;\n}\n\n.user-info button {\n  padding: 0.5rem 1rem;\n  background: var(--color-danger);\n  color: var(--color-button-text);\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.user-info button:hover {\n  background: var(--color-danger-hover);\n}\n\n/* Categories */\n.categories {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 1rem;\n  overflow-x: auto;\n  display: flex;\n  gap: 0.5rem;\n  white-space: nowrap;\n  backdrop-filter: blur(10px);\n}\n\n.categories button {\n  padding: 1rem;\n  background: var(--color-primary);\n  color: var(--color-button-text);\n  border: none;\n  border-radius: 0.5rem 0.5rem 0 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 100px;\n  max-width: 120px;\n  transition: background 0.2s;\n  white-space: normal;\n  word-wrap: break-word;\n  text-align: center;\n}\n\n.categories button:hover {\n  background: var(--color-primary-hover);\n}\n\n.categories button.active {\n  background: linear-gradient(to bottom, var(--color-yellow-gradient-start), var(--color-yellow-gradient-end));\n  color: var(--color-active-text);\n}\n\n/* Invert white/light icons to dark when category is active */\n.categories button.active .icon img {\n  filter: invert(1);\n}\n\n.categories .icon {\n  font-size: 1.5rem;\n}\n\n/* View Toggle */\n.view-toggle {\n  max-width: 28rem;\n  margin: 1.5rem auto;\n  background: var(--color-card-bg);\n  border-radius: 9999px;\n  display: flex;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.view-toggle button {\n  flex: 1;\n  padding: 0.75rem;\n  background: var(--color-card-bg);\n  color: var(--color-text-secondary);\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.view-toggle button.active {\n  background: var(--color-active-bg);\n  color: var(--color-active-text);\n}\n\n/* Main Content */\n.main-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n.prompts-list,\n.reflections-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.prompt-card {\n  background: var(--color-card-bg);\n  border-radius: var(--radius-card, 8px);\n  padding: 1.5rem;\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1));\n  border: 2px solid var(--color-border);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  transition: all 0.3s ease;\n}\n\n.prompt-card:hover {\n  box-shadow: var(--shadow-lg, 0 4px 8px rgba(0,0,0,0.15));\n  transform: translateY(-2px);\n}\n\n.prompt-card.expanded {\n  background: linear-gradient(to bottom, var(--color-yellow-gradient-start), var(--color-yellow-gradient-end));\n  border: 3px solid var(--color-yellow-gradient-end);\n  box-shadow: 0 8px 16px rgba(0,0,0,0.15), 0 0 0 1px var(--color-yellow-gradient-end);\n  transform: scale(1.01);\n  transition: all 0.3s ease;\n}\n\n.prompt-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.prompt-content,\n.reflection-content {\n  flex: 1;\n}\n\n.prompt-reflections {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-left: 2rem;\n  padding-left: 1rem;\n}\n\n.reflection-inline-card {\n  position: relative; /* Needed for absolute positioning of NEW badge */\n  background: var(--color-card-bg);\n  border-radius: 0.375rem;\n  padding: 1rem;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  grid-template-rows: auto auto auto auto;\n  align-items: center;\n  row-gap: 0.5rem;    /* Reduces vertical spacing from 16px to 8px */\n  column-gap: 1rem;   /* Keeps horizontal spacing at 16px */\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n}\n\n.reflection-prompt-text {\n  grid-column: 1 / -1;\n  grid-row: 1;\n  font-size: 0.9rem;\n  color: var(--color-text-secondary);\n  font-style: italic;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--color-border);\n  margin-bottom: 0.5rem;\n}\n\n/* NEW Badge for unviewed shared reflections */\n.new-badge {\n  position: absolute;\n  top: -6px;\n  left: 8px;\n  background: #ff0000;\n  color: white;\n  font-size: 0.7rem;\n  font-weight: bold;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  z-index: 20;\n  transition: all 0.2s ease;\n  box-shadow: 0 0 8px rgba(255, 0, 0, 0.6), 0 0 16px rgba(255, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.2);\n  user-select: none;\n}\n\n.new-badge:hover {\n  transform: scale(1.05);\n  box-shadow: 0 0 12px rgba(255, 0, 0, 0.8), 0 0 24px rgba(255, 0, 0, 0.5), 0 3px 6px rgba(0, 0, 0, 0.3);\n}\n\n.new-badge:active {\n  transform: scale(0.95);\n}\n\n.prompt-new-badge {\n  top: 3px;\n  left: 8px;\n  right: auto;\n}\n\n.match-badge {\n  position: absolute;\n  top: -6px;\n  left: 8px;\n  background: #27ae60;\n  color: white;\n  font-size: 0.7rem;\n  font-weight: bold;\n  padding: 4px 8px;\n  border-radius: 4px;\n  z-index: 2;\n  box-shadow: 0 0 8px rgba(39, 174, 96, 0.6), 0 0 16px rgba(39, 174, 96, 0.4), 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.match-badge.with-new {\n  left: 55px;\n}\n\n.prompt-match-badge {\n  top: 3px;\n  left: 8px;\n  right: auto;\n}\n\n.prompt-match-badge.with-new {\n  left: 55px;\n}\n\n.reflection-inline-note {\n  color: var(--color-text-muted);\n  font-size: 0.875rem;\n  grid-column: 1;\n  grid-row: 2;\n}\n\n.reflection-inline-buttons {\n  display: flex;\n  gap: 0.5rem;\n  grid-column: 2;\n  grid-row: 2;\n}\n\n.reflection-btn-show,\n.reflection-btn-edit,\n.reflection-btn-delete,\n.reflection-btn-transcribe,\n.reflection-btn-change-prompt {\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  appearance: none !important;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--color-primary) !important;\n  color: var(--color-button-text) !important;\n  border: none !important;\n  border-radius: 24px !important;\n  cursor: pointer;\n  font-size: 0.875rem;\n  white-space: nowrap;\n  transition: all 0.2s;\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05)) !important;\n  outline: none !important;\n}\n\n.reflection-btn-show:hover,\n.reflection-btn-edit:hover {\n  background: var(--color-primary-hover) !important;\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;\n  transform: translateY(-1px);\n}\n\n.reflection-btn-delete {\n  background: var(--color-danger) !important;\n}\n\n.reflection-btn-delete:hover {\n  background: #d32f2f !important;\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;\n  transform: translateY(-1px);\n}\n\n.reflection-btn-transcribe {\n  background: var(--color-secondary, #6c757d) !important;\n}\n\n.reflection-btn-transcribe:hover {\n  background: var(--color-secondary-hover, #5a6268) !important;\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;\n  transform: translateY(-1px);\n}\n\n.reflection-btn-change-prompt {\n  background: var(--color-accent, #8b5cf6) !important;\n}\n\n.reflection-btn-change-prompt:hover {\n  background: var(--color-accent-hover, #7c3aed) !important;\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;\n  transform: translateY(-1px);\n}\n\n.reflection-btn-show.active {\n  background: var(--color-primary) !important;\n  box-shadow: 0 0 0 2px var(--color-primary-hover) !important;\n}\n\n.reflection-btn-edit.active {\n  background: var(--color-success) !important;\n  box-shadow: 0 0 0 2px var(--color-success-hover) !important;\n}\n\n.reflection-btn-edit.active:hover {\n  background: var(--color-success-hover);\n}\n\n/* Button icons and counts */\n.reflection-btn-show .icon,\n.reflection-btn-edit .icon,\n.reflection-btn-delete .icon {\n  font-size: 1.2rem;\n}\n\n/* Context menu (ellipsis / more actions) */\n.reflection-context-menu-container {\n  position: relative;\n}\n\n.reflection-btn-more {\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  appearance: none !important;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--color-primary) !important;\n  color: var(--color-button-text) !important;\n  border: none !important;\n  border-radius: 24px !important;\n  cursor: pointer;\n  font-size: 1.1rem;\n  letter-spacing: 2px;\n  white-space: nowrap;\n  transition: all 0.2s;\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05)) !important;\n  outline: none !important;\n}\n\n.reflection-btn-more:hover {\n  background: var(--color-primary-hover) !important;\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;\n  transform: translateY(-1px);\n}\n\n.reflection-context-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 0.5rem;\n  background: var(--color-card-bg);\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  min-width: 140px;\n  width: max-content;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n}\n\n.reflection-context-menu-item {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  background: var(--color-card-bg);\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s;\n  color: var(--color-text);\n  font-size: 1rem;\n}\n\n.reflection-context-menu-item:first-child {\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n\n.reflection-context-menu-item:last-child {\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n\n.reflection-context-menu-item:hover {\n  background: var(--color-background);\n}\n\n.reflection-context-menu-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.reflection-context-menu-item-danger {\n  color: var(--color-danger, #e53935);\n}\n\n.reflection-context-menu-item-danger:hover {\n  background: var(--color-background);\n}\n\n.reflection-inline-thumbnail {\n  width: 80px;\n  height: 60px;\n  background: var(--color-black);\n  border-radius: 0.375rem;\n  overflow: hidden;\n  grid-column: 3;\n  grid-row: 2;\n}\n\n.reflection-shared-from {\n  grid-column: 1 / -1;\n  grid-row: 3;\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n  font-style: italic;\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.reflection-followup-indicator {\n  grid-column: 1 / -1;\n  grid-row: 4;\n  font-size: 0.8rem;\n  color: var(--color-primary);\n  font-style: italic;\n  padding-top: 0.4rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.reflection-tree-wrapper {\n  grid-column: 1 / -1;\n  grid-row: -1;\n  overflow-x: auto;\n}\n\n.reflection-inline-thumbnail video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.audio-placeholder,\n.text-placeholder,\n.reflection-thumbnail-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-size: 1.5rem;\n  border: 2px solid var(--color-border);\n  border-radius: 0.375rem;\n}\n\n.reflection-section {\n  margin-bottom: 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.375rem;\n  overflow: hidden;\n}\n\n.reflection-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background: var(--color-background);\n  cursor: pointer;\n  font-weight: 600;\n  color: var(--color-text);\n  transition: background 0.2s;\n  user-select: none;\n}\n\n.reflection-section-header:hover {\n  background: var(--color-border-light);\n}\n\n/* Active section header - light blue background when expanded */\n.reflection-section-header.active {\n  background: var(--color-reflection-show-bg);\n}\n\n/* Disabled section header - during recording\n   ⚠️ Applied to Video/Audio/Text section headers that are NOT currently recording\n   Prevents users from collapsing the active recording or opening other sections */\n.reflection-section-header.disabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n  pointer-events: none;\n}\n\n.reflection-section-header.disabled:hover {\n  background: var(--color-background);\n}\n\n.section-header-left {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.section-header-right {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.no-content-indicator {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: var(--color-text-secondary);\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.section-toggle {\n  color: var(--color-text-secondary);\n  font-size: 0.875rem;\n}\n\n.reflection-section-content {\n  padding: 1rem;\n  background: var(--color-card-bg);\n}\n\n.reflection-section-content textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  background: var(--color-input-bg);\n  color: var(--color-text);\n}\n\n.reflection-section-content textarea:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.reflection-section-content p {\n  margin: 0;\n  color: var(--color-text);\n  white-space: pre-wrap;\n}\n\n.reflection-section-content p.no-content {\n  color: var(--color-text-secondary);\n  font-style: italic;\n}\n\n/* React-Quill WYSIWYG Editor Styles */\n.reflection-section-content .quill {\n  background: var(--color-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 0.375rem;\n}\n\n.reflection-section-content .ql-toolbar {\n  border: 1px solid var(--color-border);\n  border-bottom: none;\n  border-radius: 0.375rem 0.375rem 0 0;\n  background: var(--color-background);\n}\n\n.reflection-section-content .ql-container {\n  border: 1px solid var(--color-border);\n  border-radius: 0 0 0.375rem 0.375rem;\n  font-size: 1rem;\n  font-family: inherit;\n  min-height: 150px;\n}\n\n.reflection-section-content .ql-editor {\n  color: var(--color-text);\n  min-height: 150px;\n  padding: 0.75rem;\n}\n\n.reflection-section-content .ql-editor.ql-blank::before {\n  color: var(--color-text-secondary);\n  font-style: italic;\n}\n\n/* Toolbar button colors */\n.reflection-section-content .ql-toolbar .ql-stroke {\n  stroke: var(--color-text);\n}\n\n.reflection-section-content .ql-toolbar .ql-fill {\n  fill: var(--color-text);\n}\n\n/* Active toolbar buttons */\n.reflection-section-content .ql-toolbar button:hover,\n.reflection-section-content .ql-toolbar button.ql-active {\n  background: var(--color-border-light);\n}\n\n/* Read-only mode (bubble theme) */\n.reflection-section-content .ql-bubble .ql-editor {\n  padding: 0;\n  border: none;\n}\n\n/* Recording prompt box - appears above media during recording/countdown */\n.recording-prompt-box {\n  background: var(--color-card-bg);\n  padding: 1.5rem 2rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  border: 2px solid var(--color-primary);\n  font-size: 1.75rem;\n  line-height: 1.6;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  font-weight: bold;\n  color: var(--color-text);\n}\n\n.btn-record,\n.btn-delete-recording {\n  padding: 0.375rem 0.75rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.btn-record {\n  background: var(--color-primary);\n  color: var(--color-button-text);\n}\n\n.btn-record:hover {\n  background: var(--color-primary-hover);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n}\n\n.btn-delete-recording {\n  background: var(--color-danger);\n  color: var(--color-button-text);\n}\n\n.btn-delete-recording:hover {\n  background: var(--color-danger-hover);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n}\n\n/* Recording Controls */\n.recording-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.recording-controls {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n  padding: 0.5rem 0;\n}\n\n/* Primary button with pill style */\n.btn-primary {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  background: var(--color-primary);\n  color: var(--color-button-text);\n}\n\n.btn-primary:hover {\n  background: var(--color-primary-hover);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Utility button: looks like a button, but deliberately lower-key than .btn-primary\n   for secondary, \"housekeeping\" actions (e.g. resend a code/link) rather than the main action */\n.btn-utility {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.375rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: transparent;\n  color: var(--color-text-secondary);\n}\n\n.btn-utility:hover:not(:disabled) {\n  background: var(--color-border-light);\n  border-color: var(--color-text-secondary);\n}\n\n.btn-utility:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.btn-stop-recording,\n.btn-pause-recording {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.btn-stop-recording {\n  background: var(--color-danger);\n  color: var(--color-button-text);\n}\n\n.btn-stop-recording:hover {\n  background: var(--color-danger-hover);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n  transform: translateY(-1px);\n}\n\n.btn-pause-recording {\n  background: var(--color-primary);\n  color: var(--color-button-text);\n}\n\n.btn-pause-recording:hover {\n  background: var(--color-primary-hover);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Audio Recording Indicator */\n.audio-recording-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 2rem;\n  background: var(--color-background);\n  border-radius: 0.5rem;\n}\n\n.audio-recording-indicator span {\n  font-size: 1rem;\n  color: var(--color-text);\n}\n\n.recording-pulse {\n  font-size: 3rem;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.1);\n  }\n}\n\n/* Audio Playback with Waveform */\n.audio-playback-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.prompt-actions {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n  align-items: stretch;\n  margin-left: auto;\n  align-self: flex-start;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n@media (max-width: 640px) {\n  .prompt-actions {\n    flex-direction: column-reverse;\n  }\n}\n\n/* Removed - now using reflection-btn-show class\n.view-button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1rem;\n  background: var(--color-card-bg);\n  color: var(--color-primary);\n  border: 2px solid var(--color-primary);\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n  gap: 0.5rem;\n}\n\n.view-button:hover {\n  background: var(--color-primary);\n  color: var(--color-button-text);\n}\n\n.view-button .icon {\n  font-size: 1.2rem;\n}\n*/\n\n.view-counts {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  font-size: 0.75rem;\n  text-align: left;\n}\n\n.prompt-text,\n.reflection-prompt {\n  font-size: 1.125rem;\n  color: var(--color-text);\n  margin-bottom: 0.5rem;\n}\n\n.prompt-category,\n.reflection-meta {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  font-style: italic;\n}\n\n.reflection-notes {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  font-style: italic;\n  margin-top: 0.5rem;\n}\n\n/* Friend suggestion metadata on prompt cards */\n.friend-suggestion-meta {\n  margin-top: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background: rgba(59, 130, 246, 0.06);\n  border-left: 3px solid var(--color-primary, #3b82f6);\n  border-radius: 0 0.25rem 0.25rem 0;\n  font-size: 0.8rem;\n}\n\n.friend-suggestion-from {\n  display: inline-block;\n  font-weight: 600;\n  color: var(--color-primary, #3b82f6);\n  margin-right: 0.5rem;\n}\n\n.friend-suggestion-date {\n  display: inline-block;\n  color: var(--color-text-secondary);\n}\n\n.friend-suggestion-note {\n  margin: 0.35rem 0 0 0;\n  color: var(--color-text-secondary);\n  font-style: italic;\n  line-height: 1.4;\n}\n\n.reflection-text {\n  margin-top: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n/* Removed - now using reflection-btn-* classes\n.prompt-card button {\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  appearance: none !important;\n  padding: 0.5rem 1.5rem;\n  background: var(--color-card-bg) !important;\n  color: var(--color-danger) !important;\n  border: 2px solid var(--color-danger) !important;\n  border-radius: 24px !important;\n  cursor: pointer;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: all 0.2s;\n  height: 100%;\n  outline: none !important;\n}\n\n.prompt-card button:hover {\n  background: var(--color-danger) !important;\n  color: var(--color-button-text) !important;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md, 0 2px 4px rgba(0,0,0,0.1)) !important;\n}\n*/\n\n/* Modal */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* Dark overlay with blur for true modal behavior */\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  z-index: 50;\n}\n\n.modal-content {\n  /* Glassmorphism effect for modal content */\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 1rem;\n  max-width: 42rem;\n  width: 100%;\n  padding: 1.5rem;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.modal-header h3 {\n  font-size: 1.25rem;\n  color: var(--color-text);\n  margin-bottom: 0.5rem;\n}\n\n.modal-header p {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.modal-header button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.modal-header button:hover {\n  color: var(--color-text-muted);\n}\n\n.modal-content input[type=\"text\"],\n.modal-content input[type=\"email\"],\n.modal-content input[type=\"password\"],\n.modal-content input[type=\"tel\"],\n.modal-content input[type=\"number\"],\n.modal-content textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n  font-family: inherit;\n  background: var(--color-input-bg);\n}\n\n.modal-content input[type=\"checkbox\"] {\n  width: auto;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.modal-content input[type=\"text\"]:focus,\n.modal-content input[type=\"email\"]:focus,\n.modal-content input[type=\"password\"]:focus,\n.modal-content input[type=\"tel\"]:focus,\n.modal-content input[type=\"number\"]:focus,\n.modal-content textarea:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.video-preview,\n.media-player {\n  width: 100%;\n  height: 16rem;\n  background: var(--color-black);\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.text-content {\n  background: var(--color-gray-50);\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.modal-actions button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.2s;\n}\n\n.modal-actions button:nth-child(1) {\n  background: var(--color-danger);\n  color: var(--color-button-text);\n}\n\n.modal-actions button:nth-child(1):hover {\n  background: var(--color-danger-hover);\n}\n\n.modal-actions button:nth-child(2) {\n  background: var(--color-primary);\n  color: var(--color-button-text);\n}\n\n.modal-actions button:nth-child(2):hover {\n  background: var(--color-primary-hover);\n}\n\n.modal-actions button:nth-child(3) {\n  background: var(--color-success);\n  color: var(--color-button-text);\n}\n\n.modal-actions button:nth-child(3):hover {\n  background: var(--color-success-hover);\n}\n\n/* Login */\n.login-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.login-box {\n  /* Glassmorphism effect - used on standalone login page */\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  padding: 2rem;\n  border-radius: 1rem;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.15);\n  width: 100%;\n  max-width: 36rem; /* Increased from 24rem to prevent header text wrapping */\n}\n\n/* Auth form content inside modals - no background since modal already has glassmorphism */\n.auth-form-content {\n  /* No background or shadow - parent modal-content provides the glassmorphism */\n}\n\n.auth-form-content h1 {\n  font-size: 1.5rem;\n  color: var(--color-text);\n  margin: 0;\n}\n\n.auth-form-content > p {\n  color: var(--color-text-secondary);\n  font-size: 0.85rem;\n  margin: 0;\n}\n\n.auth-form-content form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.auth-form-content input {\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  background: var(--color-input-bg);\n}\n\n.auth-form-content input:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.auth-form-content form button[type=\"submit\"] {\n  padding: 0.75rem;\n  background: var(--color-primary);\n  color: var(--color-button-text);\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.auth-form-content form button[type=\"submit\"]:hover {\n  background: var(--color-primary-hover);\n}\n\n.login-box h1 {\n  font-size: 1.875rem;\n  color: var(--color-text);\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n\n.login-box > p {\n  text-align: center;\n  color: var(--color-text-secondary);\n  margin-bottom: 2rem;\n  font-size: 0.875rem;\n}\n\n.login-box form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.login-box input {\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  background: var(--color-input-bg);\n}\n\n.login-box input:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.login-box form button {\n  padding: 0.75rem;\n  background: var(--color-primary);\n  color: var(--color-button-text);\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.login-box form button:hover {\n  background: var(--color-primary-hover);\n}\n\n.toggle-mode {\n  width: 100%;\n  margin-top: 1rem;\n  padding: 0.5rem;\n  background: none;\n  border: none;\n  color: var(--color-text-secondary);\n  font-size: 0.875rem;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.toggle-mode:hover {\n  color: var(--color-text-muted);\n}\n\n.forgot-password-link {\n  width: 100%;\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  background: none;\n  border: none;\n  color: var(--color-primary);\n  font-size: 0.875rem;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.forgot-password-link:hover {\n  color: var(--color-primary-hover);\n}\n\n.reset-message,\n.error-message,\n.success-message {\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n}\n\n.reset-message {\n  background: var(--color-info-bg);\n  color: var(--color-info-text);\n  border: 1px solid var(--color-info);\n}\n\n.error-message {\n  background: var(--color-error-bg);\n  color: var(--color-error-text);\n  border: 1px solid var(--color-danger);\n}\n\n.success-message {\n  background: var(--color-success-bg);\n  color: var(--color-success-text);\n  border: 1px solid var(--color-success);\n  text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .header-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .categories {\n    padding: 0.5rem;\n  }\n  \n  .categories button {\n    min-width: 80px;\n    padding: 0.75rem;\n    font-size: 0.875rem;\n  }\n  \n  .prompt-card {\n    flex-direction: column;\n  }\n  \n  .prompt-card button {\n    width: 100%;\n  }\n}\n\n/* Ensure View and Record buttons have same height */\n.prompt-actions {\n  min-height: 48px;\n}\n\n.prompt-actions > button {\n  align-self: stretch;\n  min-height: 48px;\n}\n\n/* Profile Menu */\n.profile-menu-container {\n  position: relative;\n}\n\n.profile-avatar-button {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);\n  color: var(--color-white);\n  font-weight: bold;\n  font-size: 1.2rem;\n  border: 2px solid var(--color-white);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s;\n}\n\n.profile-avatar-button:hover {\n  transform: scale(1.05);\n}\n\n.profile-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 0.5rem;\n  background: var(--color-card-bg);\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  min-width: 200px;\n  z-index: 9999;\n}\n\n.profile-dropdown button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  background: var(--color-card-bg);\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s;\n  color: var(--color-text);\n  font-size: 1rem;\n}\n\n.profile-dropdown button:first-child {\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n\n.profile-dropdown button:last-child {\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n\n.profile-dropdown button:hover {\n  background: var(--color-background);\n}\n\n/* Profile Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* Dark overlay with blur for true modal behavior */\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.profile-modal,\n.password-modal {\n  /* Glassmorphism effect for modal content */\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 1rem;\n  padding: 2rem;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);\n}\n\n.profile-modal h2,\n.password-modal h2 {\n  margin-bottom: 1.5rem;\n  color: var(--color-text);\n  font-size: 1.5rem;\n}\n\n.profile-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: var(--color-text-muted);\n  font-size: 0.875rem;\n}\n\n.form-group input,\n.form-group select {\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n  background: var(--color-input-bg);\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--color-secondary);\n}\n\n.form-group input.readonly-field {\n  background: var(--color-background);\n  color: var(--color-text-secondary);\n  cursor: not-allowed;\n}\n\n.change-password-btn {\n  background: var(--color-warning);\n  color: var(--color-white);\n  border: none;\n}\n\n.change-password-btn:hover {\n  background: var(--color-warning-hover);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n  flex-wrap: wrap;\n}\n\n.modal-actions button {\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  background: var(--color-secondary);\n  color: var(--color-button-text);\n}\n\n.modal-actions button:hover {\n  background: var(--color-secondary-hover);\n}\n\n.modal-actions button:last-child:not(.change-password-btn) {\n  background: var(--color-text-secondary);\n}\n\n.modal-actions button:last-child:not(.change-password-btn):hover {\n  background: var(--color-text-muted);\n}\n\n/* Audio Equalizer Visual Feedback */\n.equalizer-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 4px;\n  height: 40px;\n  margin-bottom: 0.75rem;\n  padding: 0 1rem;\n}\n\n.equalizer-bar {\n  width: 6px;\n  height: 8px;\n  background: var(--color-secondary);\n  border-radius: 3px;\n  transition: height 0.1s ease;\n}\n\n/* Animate bars when playing */\n.equalizer-container.playing .equalizer-bar {\n  animation: equalize 0.8s ease-in-out infinite;\n}\n\n.equalizer-container.playing .equalizer-bar:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.equalizer-container.playing .equalizer-bar:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.equalizer-container.playing .equalizer-bar:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n.equalizer-container.playing .equalizer-bar:nth-child(4) {\n  animation-delay: 0.15s;\n}\n\n.equalizer-container.playing .equalizer-bar:nth-child(5) {\n  animation-delay: 0s;\n}\n\n@keyframes equalize {\n  0%, 100% {\n    height: 8px;\n  }\n  25% {\n    height: 30px;\n  }\n  50% {\n    height: 15px;\n  }\n  75% {\n    height: 25px;\n  }\n}\n\n/* Add New Prompt Button */\n.add-prompt-button-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.add-prompt-button {\n  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));\n  color: var(--color-dark-button-text);\n  border: none;\n  border-radius: 9999px;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.add-prompt-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.add-prompt-button:active {\n  transform: translateY(0);\n}\n\n/* Filter Container */\n.filter-container {\n  display: inline-block;\n}\n\n.filter-toggle-button {\n  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));\n  color: var(--color-dark-button-text);\n  border: none;\n  border-radius: 9999px;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.filter-toggle-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.filter-toggle-button:active {\n  transform: translateY(0);\n}\n\n.filter-box-wrapper {\n  padding: 0 1rem;\n  margin-bottom: 1rem;\n}\n\n.filter-box {\n  background: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.filter-box-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\n.filter-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.filter-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.filter-row:last-child {\n  margin-bottom: 0;\n}\n\n.filter-column .filter-row:last-child {\n  margin-bottom: 0.75rem;\n}\n\n.filter-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: #ffffff;\n  font-weight: 600;\n  min-width: 100px;\n}\n\n.filter-reset-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.filter-reset-btn {\n  padding: 0.35rem 1rem;\n  font-size: 0.8rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  cursor: pointer;\n  color: #ffffff;\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.toggle-switch input:checked + .toggle-slider {\n  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));\n}\n\n.toggle-switch input:checked + .toggle-slider:before {\n  transform: translateX(24px);\n}\n\n.toggle-switch input:focus + .toggle-slider {\n  box-shadow: 0 0 1px var(--color-primary);\n}\n\n.filter-search-input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  background: white;\n  color: #333;\n  transition: border-color 0.2s;\n}\n\n.filter-search-input::placeholder {\n  color: #999;\n}\n\n.filter-search-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.filter-dropdown {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  background: white;\n  color: #333;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  min-width: 160px;\n  width: auto;\n}\n\n.filter-dropdown:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.filter-date-input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  background: white;\n  color: #333;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.filter-date-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n/* Add New Prompt Modal */\n.add-prompt-modal {\n  /* Glassmorphism effect (inherits from .modal-content but with specific sizing) */\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  min-width: 500px;\n  max-width: 600px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);\n}\n\n.add-prompt-modal h2 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: var(--color-text);\n  font-size: 1.5rem;\n}\n\n.add-prompt-modal .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.add-prompt-modal .form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--color-text);\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.add-prompt-modal textarea,\n.add-prompt-modal select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid var(--color-border);\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: inherit;\n  background-color: var(--color-input-bg);\n  color: var(--color-text);\n  transition: border-color 0.2s;\n}\n\n.add-prompt-modal textarea:focus,\n.add-prompt-modal select:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n}\n\n.add-prompt-modal textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.add-prompt-modal .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.add-prompt-modal .btn-cancel,\n.add-prompt-modal .btn-save {\n  padding: 0.75rem 2rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.add-prompt-modal .btn-cancel {\n  background-color: var(--color-border);\n  color: var(--color-text);\n}\n\n.add-prompt-modal .btn-cancel:hover {\n  background-color: var(--color-text-secondary);\n  color: var(--color-white);\n}\n\n.add-prompt-modal .btn-save {\n  background: linear-gradient(135deg, var(--color-gradient-start), var(--color-gradient-end));\n  color: var(--color-button-text);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.add-prompt-modal .btn-save:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.add-prompt-modal .btn-save:active {\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
